/**
 * Админсикй сервис для работы с пользователями
 */
export default class UserService {
	/**
	 * Инициализировать сервис
	 * @param {Object} httpClient
	 * @param {Object} errorHandler
	 */
	constructor(httpClient, errorHandler) {
		this.httpClient = httpClient
		this.errorHandler = errorHandler
	}

	/**
	 * Расширить модель пользователя
	 * @param {Object} user
	 */
	extendUser(user) {
		const productsMap = {}

		user.products.forEach(product => {
			productsMap[product.id] = product
		})

		const profile = user.profile || {}
		const fio = [profile.first_name, profile.middle_name, profile.last_name].join(" ")
		const producterUsers = user.producter_users
		// .map(producterUser => {
		// 	return { ...producterUser, product: productsMap[producterUser.product_id] }
		// })

		return { ...user, fio, producterUsers }
	}

	/**
	 * Получить пользователей
	 */
	async getUsers({ page = 1, perPage = 20, query = null } = {}) {
		try {
			const response = await this.httpClient.get(["admin/producter/user", { page, per_page: perPage, query }])
			const items = Array.isArray(response) ? response : response.items || []
			const pagination = response.pagination || {
				page,
				per_page: perPage,
				total: items.length,
				pages: 1
			}

			return {
				items: items.map(this.extendUser),
				pagination
			}
		} catch (error) {
			throw this.errorHandler.handle(error).parse("Не удалось получить пользователей")
		}
	}

	/**
	 * Получить пользователя
	 * @param {Number} id
	 */
	async getUser(id) {
		try {
			const user = await this.httpClient.get(`admin/producter/user/${id}`)

			return this.extendUser(user)
		} catch (error) {
			throw this.errorHandler.handle(error).parse("Не удалось получить пользователя")
		}
	}

	/**
	 * Удалить пользователя
	 * @param {Number} id
	 */
	async deletetUser(id) {
		try {
			return await this.httpClient.delete(`admin/producter/user/${id}`)
		} catch (error) {
			throw this.errorHandler.handle(error).parse("Не удалось удалить пользователя")
		}
	}

	/**
	 * Создать пользователей
	 */
	async createUser(data) {
		try {
			return await this.httpClient.post("admin/producter/user", data)
		} catch (error) {
			throw this.errorHandler.handle(error).parseForm("Не удалось создать пользователя")
		}
	}

	/**
	 * Удалить сессии
	 */
	async deleteSessions(userId) {
		try {
			await this.httpClient.delete(`admin/producter/user-session/${userId}`)
		} catch (error) {
			throw this.errorHandler.handle(error).parseForm("Не удалось удалить сессии")
		}
	}

	/**
	 * Связать двух пользователей
	 * @param {Number} linked_id главный
	 * @param {Number} referrer_id его поглотят
	 * @returns
	 */
	async linkUsers(linked_id, referrer_id) {
		try {
			return await this.httpClient.post("admin/producter/combine-user-products", { linked_id, referrer_id })
		} catch (error) {
			throw this.errorHandler.handle(error).parseForm("Не удалось объединить пользователей")
		}
	}
}
